import React from 'react';
import * as constants from 'constants/modal';
import { isDomainIe, formatPrice } from 'utils/utils';

import RoomFacilitiesOverlayLayout from 'layouts/RoomFacilitiesOverlayLayout/RoomFacilitiesOverlayLayout';
import PriceTrackerSignUpLayout from 'layouts/PriceTrackerSignUpLayout/PriceTrackerSignUpLayout';
import BookTransferReminderLayout from 'layouts/BookTransferReminderLayout/BookTransferReminderLayout';
import BookHandLuggageModalLayout from 'layouts/BookHandLuggageModalLayout/BookHandLuggageModalLayout';
import BookFreeHotelAmendsLayout from 'layouts/BookFreeHotelAmendsLayout/BookFreeHotelAmendsLayout';
import BookSupplierPrincipals from 'components/BookSupplierPrincipals/BookSupplierPrincipals';
import ResponsiveGallery from 'components/ResponsiveGallery/ResponsiveGallery';
import DuplicateNamesModal from 'components/DuplicateNamesModal/DuplicateNamesModal';
import OpeningHoursModal from 'components/OpeningHoursModal/OpeningHoursModal';
import PassengerListModal from 'components/AirlineSeatSelection/PassengerListModal';
import SeatListModal from 'components/AirlineSeatSelection/SeatListModal';
import CarHireOptionsList from 'components/CarHire/CarHireOptionsList';
import CarHireTermsAndConditions from 'components/CarHire/CarHireTermsAndConditions';
import AssistedBookingStatusLayout from 'layouts/AssistedBookingStatusLayout/AssistedBookingStatusLayout';
import EmailDealLayout from 'layouts/EmailDealLayout/EmailDealLayout';
import RoomOptionsLayout from 'layouts/RoomOptionsLayout/RoomOptionsLayout';

import atol from './images/atol.svg';
import abta from './images/abta.svg';
import priceMatch from './images/price_match.svg';
import monthlyPayments from './images/monthly_payments.svg';
import depositFrom29 from './images/deposit-from-29.svg';
import phoneOpeningTime from './images/phone_opening_time.svg';

const depositPP = 29;
const depositPPFormatted = formatPrice(depositPP);

export function getHtmlContent(id) {
  const html = document.getElementById(id);
  return html ? { __html: html.innerHTML } : false;
}

export const modalTypes = {
  [constants.ATOL]: {
    icon: atol,
    content: (
      <article>
        <p>You can be confident that your holiday is fully ATOL protected, giving you financial protection. We are fully covered by this scheme, giving you complete peace of mind. Our ATOL number is 10989.</p>
      </article>
    ),
  },
  [constants.ABTA]: {
    icon: abta,
    content: (
      <article>
        <p>We strive to offer the highest possible standard of service. As full members of ABTA (membership number P6847), we always operate in compliance with the strict Code of Conduct and standards of service. Our customers’ trust is our top priority.</p>
      </article>
    ),
  },
  [constants.PRICE_MATCH]: {
    icon: priceMatch,
    content: (
      <article>
        <p>We want you to love your holiday without worrying about the price. We track millions of prices every day to make sure we offer you the lowest price every time. In addition, we offer a Price Match Guarantee. If you find the same flight and hotel deal anywhere else online, we will match it, subject to standard T&amp;Cs.</p>
      </article>
    ),
  },
  [constants.WHAT_IS_THIS_PRICE]: {
    content: (
      <article>
        <h4 className="modal__content__title">What is included in this price?</h4>
        <ul className="modal__content__list">
          <li className="modal__content__list__el">
            <i className="tick-icon" aria-hidden="true" /> Return Flights
          </li>
          <li className="modal__content__list__el">
            <i className="tick-icon" aria-hidden="true" /> Hotel Accommodation
          </li>
          <li className="modal__content__list__el">
            <i className="tick-icon" aria-hidden="true" /> Selected Board Basis
          </li>
          {
            !isDomainIe() && (
              <li className="modal__content__list__el">
                <i className="tick-icon" aria-hidden="true" /> Atol and ABTA Protection
              </li>
            )
          }
          <li className="modal__content__list__el">
            <i className="tick-icon" aria-hidden="true" /> No Booking Fees
          </li>
          <li className="modal__content__list__el">
            <i className="tick-icon" aria-hidden="true" /> Price Match Guarantee
          </li>
          <li className="modal__content__list__el">
            <i className="plus-icon" aria-hidden="true" /> Optional Transfer
          </li>
          <li className="modal__content__list__el">
            <i className="plus-icon" aria-hidden="true" /> Optional Baggage
          </li>
        </ul>
      </article>
    ),
  },
  [constants.ZERO_PERCENT]: {
    icon: monthlyPayments,
    content: (
      <article>
        <p>Don’t be out of pocket. By booking with us, you can spread the cost of your holiday. Just pay a low deposit (starting from {depositPPFormatted}pp) and then 0% monthly payments, up until 14 days before you depart.</p>
      </article>
    ),
  },
  [constants.DEPOSIT_FROM]: {
    icon: depositFrom29,
    content: (
      <article>
        <p>Enjoy the holiday countdown without the financial worry. With us, you can book your holiday with a low deposit from just {depositPPFormatted} per person and pay the final balance up to 14 days before departure. </p>
      </article>
    ),
  },
  [constants.PHONE_OPENING_TIME]: {
    icon: phoneOpeningTime,
    content: (
      <article>
        <OpeningHoursModal />
      </article>
    ),
  },
  [constants.TERMS_CONDITIONS_AGENCY]: {
    content: (
      <article>
        { getHtmlContent('TCContent') && (
          <div dangerouslySetInnerHTML={getHtmlContent('TCContent')} />
        )}
      </article>
    ),
  },
  [constants.TERMS_CONDITIONS_SUPPLIER]: {
    content: (
      <article>
        <BookSupplierPrincipals />
      </article>
    ),
  },
  [constants.FACILITIES_LIST]: modal => ({
    content: (
      <article><h3>Facilities</h3><div dangerouslySetInnerHTML={{ __html: modal.config.content }} /></article>
    ),
  }),
  [constants.FACILITIES_OVERVIEW]: modal => ({
    content: (
      <RoomFacilitiesOverlayLayout
        facilities={modal.config.facilities}
        images={modal.config.images}
        overlayText={modal.config.overlayText}
        width={modal.config.width}
        slideWidth={modal.config.slideWidth}
        title={modal.config.title}
        mainImageType={modal.config.mainImageType}
        thumbnailImageType={modal.config.thumbnailImageType}
        disableThumbnails={modal.config.disableThumbnails}
      />
    ),
  }),
  [constants.FACILITIES_OVERVIEW_GALLERY]: modal => ({
    content: (
      <ResponsiveGallery
        images={modal.config.images}
        mainImageType={modal.config.mainImageType}
        loopImages={modal.config.loopImages}
      />
    ),
  }),
  [constants.PRICE_TRACKER]: modal => ({
    content: (
      <PriceTrackerSignUpLayout
        location={modal.config.location}
        isCheapestFlight={modal.config.isCheapestFlight}
        isModal={modal.config.isModal}
      />
    ),
  }),
  [constants.HAND_LUGGAGE]: modal => ({
    content: (
      <BookHandLuggageModalLayout
        airlineBaggage={modal.config.airlineBaggage}
      />
    ),
  }),
  [constants.TRANSFER_REMINDER]: modal => ({
    content: (
      <BookTransferReminderLayout
        onSubmit={modal.config.onSubmit}
      />
    ),
  }),
  [constants.FREE_HOTEL_AMENDS]: modal => ({
    content: (
      <BookFreeHotelAmendsLayout
        onSubmit={modal.config.onSubmit}
      />
    ),
  }),
  [constants.CHECK_DUPLICATE_NAMES]: modal => ({
    content: (
      <DuplicateNamesModal
        onSubmit={modal.config.onSubmit}
        onGoBack={modal.config.toggleModalBound}
        onContinue={() => { modal.config.toggleModalBound(); modal.config.postForm(); }}
      />
    ),
  }),
  [constants.ASSISTED_BOOKING_STATUS]: () => ({
    content: (
      <AssistedBookingStatusLayout />
    ),
  }),
  [constants.EMAIL_DEAL]: () => ({
    content: (
      <EmailDealLayout />
    ),
  }),
  [constants.ROOM_OPTIONS]: () => ({
    content: (
      <RoomOptionsLayout />
    ),
  }),
  [constants.AIRLINE_PASSENGER_LIST]: () => ({
    content: (
      <PassengerListModal />
    ),
  }),
  [constants.AIRLINE_SEAT_LIST]: modal => ({
    content: (
      <SeatListModal
        {...modal.config}
      />
    ),
  }),
  [constants.CAR_HIRE_OPTIONS]: modal => ({
    content: (
      <CarHireOptionsList {...modal.config} />
    ),
  }),
  [constants.CAR_TERMS_AND_CONDITIONS]: modal => ({
    content: (
      <CarHireTermsAndConditions {...modal.config} />
    ),
  }),
};

const getModalData = (modal) => {
  const modalData = modalTypes[modal.name];
  return (typeof modalData === 'function') ? modalData(modal) : modalData;
};

export default getModalData;



/** WEBPACK FOOTER **
 ** ./src/components/Modal/content.jsx
 **/